import { render, staticRenderFns } from "./UnhealthyVehiclesTable.vue?vue&type=template&id=6b878c89&scoped=true&"
import script from "./UnhealthyVehiclesTable.vue?vue&type=script&lang=js&"
export * from "./UnhealthyVehiclesTable.vue?vue&type=script&lang=js&"
import style0 from "./UnhealthyVehiclesTable.vue?vue&type=style&index=0&id=6b878c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b878c89",
  null
  
)

export default component.exports